import { render, staticRenderFns } from "./TintometricoCorante.vue?vue&type=template&id=18afc534"
import script from "./TintometricoCorante.vue?vue&type=script&lang=js"
export * from "./TintometricoCorante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports